/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_Import_Summary_Duplicates_OneInputs */

const en_ui_import_summary_duplicates_one = /** @type {(inputs: Ui_Import_Summary_Duplicates_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} duplicate`)
};

const de_ui_import_summary_duplicates_one = /** @type {(inputs: Ui_Import_Summary_Duplicates_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Duplikat`)
};

/**
* | output |
* | --- |
* | "{count} duplicate" |
*
* @param {Ui_Import_Summary_Duplicates_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_import_summary_duplicates_one = /** @type {((inputs: Ui_Import_Summary_Duplicates_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Import_Summary_Duplicates_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_import_summary_duplicates_one(inputs)
	return de_ui_import_summary_duplicates_one(inputs)
});